module.exports = __webpack_public_path__ + "static/logo-fa5a1c2c2ee229881d6793cb04e00439.png";